<template>
  <div class="mt-2">
    <div
      class="nps-area mb-4"
      v-if="justView || addQuestionTemplate === 'default'"
    >
      <div
        class="question-area"
        :style="{
          color: textColor || '#000000',
        }"
      >
        <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ text }} </span>
      </div>
      <div
        v-if="justView"
        class="grade-area"
        style="display: flex; justify-content: center;"
      >
        <span v-for="(button, i) in buttons" :style="handleStyle(i)" :key="i">
          {{ button.value }}
        </span>

        <applicable
          style="margin-top: -10px;"
          v-if="reviewAnswer === -1"
          :justView="justView"
          :itemId="index"
        />
      </div>
      <div v-else>
        <div>
          <div class="grade-area">
            <button
              v-for="(button, i) in buttons"
              @click="handleClick(button.value, i)"
              @mouseover="handleHover($event.target, i, true)"
              @mouseleave="handleHover($event.target, i, false)"
              :style="handleStyle(i)"
              :key="i"
            >
              {{ button.value }}
            </button>
          </div>
          <applicable
            class="applicable-btn"
            v-if="applicableEnabled"
            :itemId="index"
            v-model="applicabled"
            :selectedButton="selectedButton"
            @click.native="selectedButton = !selectedButton"
            :lang="lang"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="nps-area-big mb-4">
        <div
          class="question-area"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </div>
        <div>
          <div>
            <div class="grade-area">
              <button
                v-for="(button, i) in buttons"
                @click="handleClick(button.value, i)"
                @mouseover="handleHover($event.target, i, true)"
                @mouseleave="handleHover($event.target, i, false)"
                :style="handleStyle(i)"
                :key="i"
              >
                {{ button.value }}
              </button>
            </div>
            <applicable
              class="applicable-big"
              v-if="applicableEnabled"
              :itemId="index"
              v-model="applicabled"
              :selectedButton="selectedButton"
              @click.native="selectedButton = !selectedButton"
              :lang="lang"
            />
          </div>
        </div>
      </div>
    </div>

    <comment-area
      :clickButton="expandComment"
      :template="addQuestionTemplate"
      v-if="commentEnabled && !justView"
      v-model="comment"
    />

    <p
      v-if="hasComment && justView"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>

    <hr />
  </div>
</template>

<script>
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  name: 'npsScale',

  components: {
    commentArea,
    applicable,
  },

  data: () => ({
    items: 11,
    position: null,
    buttons: [
      { value: 0, selected: false, color: '#d62027' },
      { value: 1, selected: false, color: '#d62027' },
      { value: 2, selected: false, color: '#f05223' },
      { value: 3, selected: false, color: '#f36f21' },
      { value: 4, selected: false, color: '#faa823' },
      { value: 5, selected: false, color: '#ffca27' },
      { value: 6, selected: false, color: '#ecdb12' },
      { value: 7, selected: false, color: '#e8e73d' },
      { value: 8, selected: false, color: '#c5d92d' },
      { value: 9, selected: false, color: '#afd136' },
      { value: 10, selected: false, color: '#64b64d' },
    ],
    gradeSelected: null,
    comment: null,
    applicabled: null,
    selectedButton: false,
    expandComment: false,
  }),

  props: {
    textColor: { type: String, required: false },
    text: { type: String, required: true },
    itemId: { type: String, required: true },
    index: { type: Number, required: true },
    justView: { type: Boolean, default: false },
    selected: { type: Number },
    colorTemplate: { type: String, required: false, default: 'colors' },
    template: { type: String, required: false, },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: false },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    idQuestion: { type: String, required: true },
    lang: { type: String, default: 'br' }
  },

  watch: {
    comment: function watchComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.selectedButton = true;
        this.buttons.forEach((el) => {
          el.selected = false;
        });

        this.$emit('input', {
          review: -1,
          comment: this.comment,
          position: this.itemId,
          _id: this.idQuestion,
        });
      } else {
        this.gradeSelected = value;
      }
    },
    gradeSelected: function watchGradeSelected(value) {
      this.gradeSelected = value;
    },
  },

  methods: {
    handleClick(value, i) {
      this.expandComment = true;

      this.buttons.forEach((el) => {
        el.selected = false;
      });

      if (value !== this.gradeSelected) {
        this.buttons[i].selected = true;
        this.gradeSelected = value;
      } else {
        this.expandComment = false;
        this.gradeSelected = null;
      }

      this.update();
    },

    handleStyle(i) {
      const style = { borderColor: '#bdbdbd', color: '#bdbdbd' };

      if (this.colorTemplate !== 'grades') {
        style.borderColor = this.buttons[i].color;
        style.color = this.buttons[i].color;
      }

      if (this.buttons[i].selected) {
        style.background = this.buttons[i].color;
        style.color = '#fff';
        style.transform = 'scale(1.2)';
        style.marginLeft = '4px';
        style.marginRight = '4px';
      } else {
        style.transform = 'scale(1)';
        style.marginLeft = '0';
        style.marginRight = '0';
      }

      if(this.template && this.template === 'gradient'){

        style.background = this.buttons[i].color;
        style.borderColor = '#fff';

        style.color = '#fff';

        if(this.buttons[i].selected){
          style.opacity = '1';
          style.transform = 'scale(1.2)';
          style.marginLeft = '4px';
          style.marginRight = '4px';
        } else {
          style.opacity = '0.6';
          style.transform = 'scale(1)';
          style.marginLeft = '0';
          style.marginRight = '0';
        }

        } else if(this.template && this.template === 'static'){

        if(this.buttons[i].selected){
          style.opacity = '1';
          style.transform = 'scale(1.2)';
          style.marginLeft = '4px';
          style.marginRight = '4px';
        } else {
          style.opacity = '0.6';
          style.transform = 'scale(1)';
          style.marginLeft = '0';
          style.marginRight = '0';
        }
        style.color = '#fff';
        style.borderColor = '#fff';

        if(this.buttons[i].value === 7 || this.buttons[i].value === 8){

          style.background = '#ecdb12';

        } else if(this.buttons[i].value === 9 || this.buttons[i].value === 10){
          style.background = '#4ce595';

        } else {
          style.background = '#d62027'

        }
        }

      return style;
    },

    handleHover(element, i, active) {
      if(this.template && this.template === 'gradient'){

        if (active) {
          element.style.opacity = '1'
          element.style.transform = 'scale(1.2)';
          element.style.marginLeft = '4px'
          element.style.marginRight = '4px'
        } else if (!this.buttons[i].selected) {
          element.style.opacity = '0.6'
          element.style.transform = 'scale(1)';
          element.style.marginLeft = '0'
          element.style.marginRight = '0'
        }


        } else if(this.template && this.template === 'static'){

        if (active) {
          element.style.opacity = '1'
          element.style.transform = 'scale(1.2)';
          element.style.marginLeft = '4px'
          element.style.marginRight = '4px'
        } else if (!this.buttons[i].selected) {
          element.style.opacity = '0.6'
          element.style.transform = 'scale(1)';
          element.style.marginLeft = '0'
          element.style.marginRight = '0'
        }

        } else if (active) {
          element.style.backgroundColor = this.buttons[i].color;
          element.style.color = '#fff';

          element.style.transform = 'scale(1.2)';
          element.style.marginLeft = '4px'
          element.style.marginRight = '4px'

        } else if (!this.buttons[i].selected) {
          element.style.transform = 'scale(1)';
          element.style.marginLeft = '0'
          element.style.marginRight = '0'

          if (this.colorTemplate === 'colors') {
            element.style.backgroundColor = '#fff';
            element.style.color = this.buttons[i].color;
            element.style.borderColor = this.buttons[i].color;
          } else {
            element.style.backgroundColor = '#fff';
            element.style.color = '#bdbdbd';
          }
        }
    },

    update() {
      this.selectedButton = false;

      this.$emit('input', {
        review: this.gradeSelected,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },

  mounted() {
    if (this.selected >= 0) {
      this.buttons.forEach((el) => {
        if (el.value === this.selected) {
          el.selected = true;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.applicable-big {
  margin-top: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 65%;
}

.nps-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .grade-area {
    display: flex;
    flex-direction: row;

    button {
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 30px;
      max-height: 38px;
      margin-top: 10px;
      outline: 0;
    }

    span {
      text-align: center;
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 30px;
      outline: 0;
    }
  }
}

.nps-area-big {
  //display: flex;
  align-items: center;
  justify-content: center;

  .question-area {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .grade-area {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 54px;
      max-height: 48px;
      min-height: 48px;
      margin-top: 10px;
      outline: 0;
    }

    span {
      text-align: center;
      border: 1px solid $gray;
      border-radius: 4px;
      color: $gray;
      padding: 4px;
      background: transparent;
      min-width: 30px;
      outline: 0;
    }
  }
}

.comment-area {
  font-style: italic;
}

.applicable-btn {
  float: right;
}

@media only screen and (max-width: 1200px) {
  .applicable-big {
    margin-top: 0px;
  }

  .nps-area-big {
    align-items: center;
    justify-content: center;

    .question-area {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .grade-area {
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        border: 1px solid $gray;
        border-radius: 4px;
        color: $gray;
        padding: 4px;
        background: transparent;
        min-width: 9%;
        max-height: 40px;
        min-height: 40px;
        margin-top: 10px;
        outline: 0;
      }

      span {
        text-align: center;
        border: 1px solid $gray;
        border-radius: 4px;
        color: $gray;
        padding: 4px;
        background: transparent;
        min-width: 30px;
        outline: 0;
      }
    }
  }

  .nps-area {
    flex-direction: column;

    .grade-area {
      margin-top: 16px;

      button {
        padding: 6px;
        min-width: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/nps/index.vue